import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      <h1>Domov</h1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
          <ul className='cards__items'>
            <CardItem
              text='Školiteľ'
              label= 'doc. RNDr. Ľudmila Jašková, PhD.'
              path='/'
            />
            
             
          </ul>
          
          <ul className='cards__items'>
          <CardItem
              src='images/img1.png'
              text='Cieľ'
              label='Vytvoriť ozvučené programovacie prostredie na báze jazyka umožňujúceho programovať jednoduché
              melódie.'
              path='/'
            />
             </ul>
            <ul className='cards__items'>
            <CardItem
              text='Anotácia'
              label='Autorka vytvorí plne ozvučené detské programovacie prostredie s vlastným kompilátorom alebo
              interpreterom. Základné príkazy zabudovaného programovacieho jazyka budú slúžiť na prehratie
              tónov zvoleným hudobným nástrojom. Tieto príkazy bude možné použiť aj v rámci komplikovanejších
              štruktúr, ako je cyklus, príkaz vetvenia, podprogram. Editor kódu bude mať zabudovanú kontrolu
              syntaxe a funkciu ponuky príkazov. Vytváraný program sa bude dať uložiť do súboru a následne
              z neho načítať a spustiť.
              Ako vývojový nástroj zvažujeme použiť prostredie umožňujúce programovať v jazyku Java.'
              path='/'
            />
            </ul>
          <ul className='cards__items'>
            
            <CardItem
              text='Obsah'
              label=   '- Východisková kapitola '
              labela=  '   -> Podporné technológie pre nevidiach '
              labelb=  '   -> Prehľad existujúch zvukových programovacích prostredí'
              labelc=  '   -> Vývojové prostredie'
              label1=  '- Špecifikácia'
              labeld=  '   -> Základné princípy programovacieho prostredia'
              labele=  '   -> Štruktúra programu'
              labelf=  '   -> Príkazy jazyka tonik'
              labelg=  '   -> Program'
              label2 = '- Navrh'
              labelh = '   -> Používateľské rozhranie'
              label3 = '- Implementácia'
              labeli = '   -> Štruktúra kódu'
              labelj = '   -> Implementácia príkazov jazyka TonIK'
              labelk = '   -> Vykonávanie programu'
              label4 = '- Testovanie'      
              path='/products'
            />
           
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Cards;